import { FilterDef } from "@/stores/filters/FilterDef";
import { FilterParamValue } from "./FilterParamValue";

export class EvaluationFilterDef extends FilterDef {

	constructor() {
		super([
			'pupilIds',
			'goalIds'
		]);
	}

	get pupilId(): string | null {
		return this.getParamValues('pupilIds')[0]?.id.toString() || null;
	}

	set pupilId(value: string) {
		this.setParamValues('pupilIds', [new FilterParamValue(value, value)]);
	}

	get goalId(): string | null {
		return this.getParamValues('goalIds')[0]?.id.toString() || null;
	}

	set goalId(value: string) {
		this.setParamValues('goalIds', [new FilterParamValue(value, value)]);
	}

}
